<h1>Demo ECIF response scenarios</h1>
<div class="d-flex" style="gap: 10px">
  <button (click)="ecifResponse('failed')" type="button" class="btn btn-primary">Ecif Response Fail</button>
  <button (click)="ecifResponse('success')" type="button" class="btn btn-primary">Ecif Pass with exact match</button>
  <button (click)="ecifResponse('suggest')" type="button" class="btn btn-primary">Ecif pass address
    suggesstion</button>
</div>

<div class="modal fade show d-block" tabindex="-1" *ngIf="showAddressPopup"
  style="background-color: rgba(0, 0, 0, 0.5);">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'address-validation-popup.popupTitle' | translate}}</h5>
        <!-- <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button> -->
      </div>
      <div class="modal-body">
        <address-validation-popup *ngIf="addressSuggestionResponse" (addressDataEmitter)="receivedAddress($event)"
          [ecifResponseData]="addressSuggestionResponse"></address-validation-popup>
      </div>
      <!-- <div class="modal-footer">
        <button class="btn btn-secondary" (click)="onContinuePopup()">Save</button>
      </div> -->
    </div>
  </div>
</div>